import type { SVGProps } from 'react';

export interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

function base({ size = 40, ...rest }: IconProps) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    'aria-hidden': true,
    focusable: false,
    ...rest,
  } as const;
}

export function IconHome(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 3.2 2.8 11h2.6v9.3h5.2v-6h2.8v6h5.2V11h2.6L12 3.2z" />
    </svg>
  );
}

export function IconSearch(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M10.2 3.5a6.7 6.7 0 1 0 4.1 12l4.8 4.8 1.7-1.7-4.8-4.8a6.7 6.7 0 0 0-5.8-10.3zm0 2.4a4.3 4.3 0 1 1 0 8.6 4.3 4.3 0 0 1 0-8.6z" />
    </svg>
  );
}

export function IconUser(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 3a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 11c4.4 0 8 2.2 8 5v2H4v-2c0-2.8 3.6-5 8-5z" />
    </svg>
  );
}

export function IconQueue(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M3 5h18v2.6H3zm0 5.7h18v2.6H3zm0 5.7h11v2.6H3z" />
    </svg>
  );
}

export function IconLock(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 2.5a4.5 4.5 0 0 1 4.5 4.5v3h1A1.5 1.5 0 0 1 19 11.5v8a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19.5v-8A1.5 1.5 0 0 1 6.5 10h1V7A4.5 4.5 0 0 1 12 2.5zm0 2.4A2.1 2.1 0 0 0 9.9 7v3h4.2V7A2.1 2.1 0 0 0 12 4.9z" />
    </svg>
  );
}

export function IconQr(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M3 3h8v8H3zm2 2v4h4V5zm8-2h8v8h-8zm2 2v4h4V5zM3 13h8v8H3zm2 2v4h4v-4zm8-2h3v3h-3zm5 0h3v3h-3zm-5 5h3v3h-3zm5 0h3v3h-3z" />
    </svg>
  );
}

export function IconPlay(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M7 4.5v15l12-7.5z" />
    </svg>
  );
}

export function IconPause(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M6 4h4.5v16H6zm7.5 0H18v16h-4.5z" />
    </svg>
  );
}

export function IconNext(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M5 5v14l10-7zm11 0h3v14h-3z" />
    </svg>
  );
}

export function IconGlobe(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 2.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm0 2.3c-.8 0-2 2.3-2.5 6h5c-.5-3.7-1.7-6-2.5-6zm-3.3.8A7.2 7.2 0 0 0 5 10.8h2.2c.2-2.1.7-3.9 1.5-5.2zm6.6 0c.8 1.3 1.3 3.1 1.5 5.2H19a7.2 7.2 0 0 0-3.7-5.2zM5 13.2a7.2 7.2 0 0 0 3.7 5.2c-.8-1.3-1.3-3.1-1.5-5.2zm4.5 0c.5 3.7 1.7 6 2.5 6s2-2.3 2.5-6zm7.3 0c-.2 2.1-.7 3.9-1.5 5.2a7.2 7.2 0 0 0 3.7-5.2z" />
    </svg>
  );
}

export function IconLogout(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4 3h9v2.5H6.5v13H13V21H4zm11.5 4 5 5-5 5-1.8-1.8 2-2H9v-2.4h6.7l-2-2z" />
    </svg>
  );
}

export function IconNote(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M13.5 3v11.2a4 4 0 1 1-2.4-3.7V3zm-4.4 9.9a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2z" />
    </svg>
  );
}

export function IconClose(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="m5.7 4 6.3 6.3L18.3 4 20 5.7 13.7 12l6.3 6.3-1.7 1.7-6.3-6.3L5.7 20 4 18.3l6.3-6.3L4 5.7z" />
    </svg>
  );
}

export function IconArrowLeft(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M10.6 4.4 3 12l7.6 7.6 1.8-1.8L7.8 13.3H21v-2.6H7.8l4.6-4.5z" />
    </svg>
  );
}

export function IconChevronRight(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M8.6 4.4 6.8 6.2 12.6 12l-5.8 5.8 1.8 1.8L16.2 12z" />
    </svg>
  );
}

export function IconCaretDown(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M6 9.2h12L12 16z" />
    </svg>
  );
}
